import { render, staticRenderFns } from "./StatusOrder.vue?vue&type=template&id=0496ec50&scoped=true"
import script from "./StatusOrder.vue?vue&type=script&lang=js"
export * from "./StatusOrder.vue?vue&type=script&lang=js"
import style0 from "./StatusOrder.vue?vue&type=style&index=0&id=0496ec50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0496ec50",
  null
  
)

export default component.exports